import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { environment } from '@environments/environment';
import { User } from '@shared/models/user';
import { BehaviorSubject, Observable, tap } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  private http: HttpClient = inject(HttpClient);

  public isConnected: BehaviorSubject<boolean> = new BehaviorSubject(false);
  public connectedUser!: User;

  public getMe(): Observable<User> {
    return this.http.get<User>(`${environment.api.root}/me`).pipe(
      tap((response: User) => this.connectedUser = response)
    );
  }
}
